import { Directive, ElementRef, inject, input, output } from '@angular/core';
import { catchError, of, tap } from 'rxjs';
import { ServiceStateEnum } from '@mwe/constants';
import { copyToClipboard } from '@mwe/utils';

@Directive({
  selector: '[mweCopyToClipboard]',
  host: {
    '(click)': 'copy()',
    '(touchstart)': 'copy()',
  },
})
export class CopyToClipboardDirective<T> {
  mweCopyToClipboard = input<T>();

  readonly copyError = output<ServiceStateEnum.ERROR>();
  readonly copySuccess = output<ServiceStateEnum.SUCCESS>();

  private elementRef: ElementRef<T> = inject(ElementRef);

  copy() {
    const textToCopy = this.mweCopyToClipboard() ?? (this.elementRef.nativeElement as HTMLElement).innerText;
    if (!textToCopy) {
      this.copyError.emit(ServiceStateEnum.ERROR);
      return;
    }
    copyToClipboard(textToCopy)
      .pipe(
        tap(() => {
          this.copySuccess.emit(ServiceStateEnum.SUCCESS);
        }),
        catchError(_ => {
          this.copyError.emit(ServiceStateEnum.ERROR);
          return of(null);
        }),
      )
      .subscribe();
  }
}
